import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = {
    lat: String,
    lng: String,
  };
  static map;

  connect() {
    this.map = new window.google.maps.Map(document.getElementById('google-map'), {
      center: new window.google.maps.LatLng(this.latValue, this.lngValue),
      zoom: 10,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.TOP_LEFT, // ズームボタンを左上に配置
      },
    });

    const response = fetch(window.location, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken(),
      },
    });
    response
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let currentInfoWindow = null;
        const bounds = new window.google.maps.LatLngBounds();

        data.forEach((data) => {
          const marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(data.lat, data.lng),
            map: this.map,
          });
          bounds.extend(marker.position);

          // InfoWindow の作成
          const infowindow = new window.google.maps.InfoWindow({
            content: `<div style="overflow: scroll; max-height: 382px">
                        <a href="/spots/${data.id}">
                          <div style="margin-top: 5px">${data.name}</div>
                          <div><img src=${data.image} width="100%" /></div>
                        </a>
                      </div>`,
          });

          // マーカーがクリックされたときに InfoWindow を表示
          marker.addListener('click', function () {
            infowindow.open(this.map, marker); // マーカーに InfoWindow を開く
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }

            currentInfoWindow = infowindow;
          });
        });
        this.map.fitBounds(bounds);
      });
  }
}
